import { AppError } from './AppError';


export class UnAuthorizedError extends AppError {}
